"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

var _taggedTemplateLiteral = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;

var code_1 = require("./code");

var ValueError = /*#__PURE__*/function (_Error) {
  _inherits(ValueError, _Error);

  var _super = _createSuper(ValueError);

  function ValueError(name) {
    var _this;

    _classCallCheck(this, ValueError);

    _this = _super.call(this, "CodeGen: \"code\" for ".concat(name, " not defined"));
    _this.value = name.value;
    return _this;
  }

  return _createClass(ValueError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UsedValueState;

(function (UsedValueState) {
  UsedValueState[UsedValueState["Started"] = 0] = "Started";
  UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})(UsedValueState = exports.UsedValueState || (exports.UsedValueState = {}));

exports.varKinds = {
  const: new code_1.Name("const"),
  let: new code_1.Name("let"),
  var: new code_1.Name("var")
};

var Scope = /*#__PURE__*/function () {
  function Scope() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        prefixes = _ref.prefixes,
        parent = _ref.parent;

    _classCallCheck(this, Scope);

    this._names = {};
    this._prefixes = prefixes;
    this._parent = parent;
  }

  _createClass(Scope, [{
    key: "toName",
    value: function toName(nameOrPrefix) {
      return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
  }, {
    key: "name",
    value: function name(prefix) {
      return new code_1.Name(this._newName(prefix));
    }
  }, {
    key: "_newName",
    value: function _newName(prefix) {
      var ng = this._names[prefix] || this._nameGroup(prefix);

      return "".concat(prefix).concat(ng.index++);
    }
  }, {
    key: "_nameGroup",
    value: function _nameGroup(prefix) {
      var _a, _b;

      if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) {
        throw new Error("CodeGen: prefix \"".concat(prefix, "\" is not allowed in this scope"));
      }

      return this._names[prefix] = {
        prefix: prefix,
        index: 0
      };
    }
  }]);

  return Scope;
}();

exports.Scope = Scope;

var ValueScopeName = /*#__PURE__*/function (_code_1$Name) {
  _inherits(ValueScopeName, _code_1$Name);

  var _super2 = _createSuper(ValueScopeName);

  function ValueScopeName(prefix, nameStr) {
    var _this2;

    _classCallCheck(this, ValueScopeName);

    _this2 = _super2.call(this, nameStr);
    _this2.prefix = prefix;
    return _this2;
  }

  _createClass(ValueScopeName, [{
    key: "setValue",
    value: function setValue(value, _ref2) {
      var property = _ref2.property,
          itemIndex = _ref2.itemIndex;
      this.value = value;
      this.scopePath = (0, code_1._)(_templateObject || (_templateObject = _taggedTemplateLiteral([".", "[", "]"])), new code_1.Name(property), itemIndex);
    }
  }]);

  return ValueScopeName;
}(code_1.Name);

exports.ValueScopeName = ValueScopeName;
var line = (0, code_1._)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n"], ["\\n"])));

var ValueScope = /*#__PURE__*/function (_Scope) {
  _inherits(ValueScope, _Scope);

  var _super3 = _createSuper(ValueScope);

  function ValueScope(opts) {
    var _this3;

    _classCallCheck(this, ValueScope);

    _this3 = _super3.call(this, opts);
    _this3._values = {};
    _this3._scope = opts.scope;
    _this3.opts = _objectSpread(_objectSpread({}, opts), {}, {
      _n: opts.lines ? line : code_1.nil
    });
    return _this3;
  }

  _createClass(ValueScope, [{
    key: "get",
    value: function get() {
      return this._scope;
    }
  }, {
    key: "name",
    value: function name(prefix) {
      return new ValueScopeName(prefix, this._newName(prefix));
    }
  }, {
    key: "value",
    value: function value(nameOrPrefix, _value) {
      var _a;

      if (_value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
      var name = this.toName(nameOrPrefix);
      var prefix = name.prefix;
      var valueKey = (_a = _value.key) !== null && _a !== void 0 ? _a : _value.ref;
      var vs = this._values[prefix];

      if (vs) {
        var _name = vs.get(valueKey);

        if (_name) return _name;
      } else {
        vs = this._values[prefix] = new Map();
      }

      vs.set(valueKey, name);
      var s = this._scope[prefix] || (this._scope[prefix] = []);
      var itemIndex = s.length;
      s[itemIndex] = _value.ref;
      name.setValue(_value, {
        property: prefix,
        itemIndex: itemIndex
      });
      return name;
    }
  }, {
    key: "getValue",
    value: function getValue(prefix, keyOrRef) {
      var vs = this._values[prefix];
      if (!vs) return;
      return vs.get(keyOrRef);
    }
  }, {
    key: "scopeRefs",
    value: function scopeRefs(scopeName) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._values;
      return this._reduceValues(values, function (name) {
        if (name.scopePath === undefined) throw new Error("CodeGen: name \"".concat(name, "\" has no value"));
        return (0, code_1._)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", "", ""])), scopeName, name.scopePath);
      });
    }
  }, {
    key: "scopeCode",
    value: function scopeCode() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._values;
      var usedValues = arguments.length > 1 ? arguments[1] : undefined;
      var getCode = arguments.length > 2 ? arguments[2] : undefined;
      return this._reduceValues(values, function (name) {
        if (name.value === undefined) throw new Error("CodeGen: name \"".concat(name, "\" has no value"));
        return name.value.code;
      }, usedValues, getCode);
    }
  }, {
    key: "_reduceValues",
    value: function _reduceValues(values, valueCode) {
      var _this4 = this;

      var usedValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var getCode = arguments.length > 3 ? arguments[3] : undefined;
      var code = code_1.nil;

      var _loop = function _loop(prefix) {
        var vs = values[prefix];
        if (!vs) return "continue";
        var nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
        vs.forEach(function (name) {
          if (nameSet.has(name)) return;
          nameSet.set(name, UsedValueState.Started);
          var c = valueCode(name);

          if (c) {
            var def = _this4.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
            code = (0, code_1._)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", "", " ", " = ", ";", ""])), code, def, name, c, _this4.opts._n);
          } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) {
            code = (0, code_1._)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", "", "", ""])), code, c, _this4.opts._n);
          } else {
            throw new ValueError(name);
          }

          nameSet.set(name, UsedValueState.Completed);
        });
      };

      for (var prefix in values) {
        var _ret = _loop(prefix);

        if (_ret === "continue") continue;
      }

      return code;
    }
  }]);

  return ValueScope;
}(Scope);

exports.ValueScope = ValueScope;